// import Vue from 'vue';
// import {getField, updateField} from 'vuex-map-fields';
import Shopify from './shopify';

export default {
  namespaced: true,

  modules: {
    shopify: Shopify,
  },

  state: {
    enabled: false,
  },

  getters: {
    enabled: state => {
      return state.enabled;
    },
  },

  mutations: {
    enabled: (state, payload) => {
      state.enabled = payload;
    },
  },

};
